import { render, staticRenderFns } from "./Workboard.vue?vue&type=template&id=2418d5c6"
import script from "./Workboard.vue?vue&type=script&lang=js"
export * from "./Workboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports